const config = {
  apiUrl: 'https://api-dot-bsi-covid19.uc.r.appspot.com/' // producción
  // apiUrl: 'https://qa-dot-api-dot-bsi-covid19.uc.r.appspot.com/' // producción
}

export default config
